// extracted by mini-css-extract-plugin
module.exports = {"button":"MoneyButton_button__2egZN"};